import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.price__rrp-info-btn');

  if (btn) {
    const wrapper = btn.closest('.price__compare-wrapper');
    const tooltip = wrapper ? wrapper.querySelector('.price__rrp-tooltip') : null;

    if (!tooltip) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';

    // Minden más tooltip bezárása
    document.querySelectorAll('.price__rrp-tooltip').forEach(t => { t.hidden = true; });
    document.querySelectorAll('.price__rrp-info-btn').forEach(b => { b.setAttribute('aria-expanded', 'false'); });

    // Ha nem volt nyitva, nyissuk meg
    if (!isOpen) {
      tooltip.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }

    e.stopPropagation();
    return;
  }

  // Kattintás máshova → minden tooltip bezárása
  document.querySelectorAll('.price__rrp-tooltip').forEach(t => { t.hidden = true; });
  document.querySelectorAll('.price__rrp-info-btn').forEach(b => { b.setAttribute('aria-expanded', 'false'); });
});
